export enum HueEnum {
  EMERALD_LAKE,
  PINE_FOREST,
  BLUE_SKY,
  ROSE_WATER,
  LILAC_BLOSSOM,
}